var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-dialog',{attrs:{"persistent":"","max-width":"500px","transition":"dialog-transition"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('card-loading',{attrs:{"loadingText":_vm.loadingText}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }